import { render } from "./MattermostView.vue?vue&type=template&id=657a2e7a&scoped=true"
const script = {}

import "./MattermostView.vue?vue&type=style&index=0&id=657a2e7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657a2e7a"]])

export default __exports__